import * as React from 'react';
import { Solution } from '../Enum/Solution';

const map = <T, U>(collection: Iterable<T>, callback: (item: T) => U) => Array.prototype.map.call(collection, callback);

interface SolutionTabNavigationProps {
    activeSolution: Solution
}

export class SolutionTabNavigation extends React.PureComponent<SolutionTabNavigationProps> {
    public render() {
        // The SolutionTabNavigation component is used to change the active menu items inside the TYPO3 navigation
        return '';
    }

    public componentDidMount() {
        // Trigger event to close the mobile navigation
        document.dispatchEvent(new Event('li.product-finder.closeNav'));

        const activeSolution = this.props.activeSolution;
        const menuItems = document.querySelectorAll('[data-solution]') as unknown as Iterable<HTMLElement>;
        map(menuItems, menuItem => {
            if (menuItem.dataset.solution === activeSolution) {
                menuItem.classList.add('active');
            } else {
                menuItem.classList.remove('active');
            }
        });
    }
}
